import {getPriceWithCurrency} from "./helpers";
import store from "../store";

/**
 *
 * @param price {string|number|null}
 * @param feature {featureInterface}
 * @param fabricatorData {object}
 * @param messages {object} intl messages object (t obe able to use in the receipt)
 * @return {string}
 */
export const getPriceWithIncluded = (price, feature, fabricatorData, messages) => {
  if (price) {
    return getPriceWithCurrency(fabricatorData.settings, price, feature, false)
  }
  if (feature && fabricatorData.isLowes && (feature.partId === "center_island_sink" || feature.partId === "sink")) {
    return messages["navItem.priceNotIncluded"]
  }
  return messages["navItem.priceIncluded"]
}

/**
 * returns actual price property
 * @param feature {featureInterface}
 * @param fabricatorSettings {object}
 * @return {string|number|null}
 */
export const getFeaturePriceProperty = (feature, fabricatorSettings = null) => {
  let settings = fabricatorSettings;
  if (!settings) {
    settings = store.getState().fabricatorState.settings;
  }
  if (settings.useFabricatorCostPrices) { // show fabricator prices instead of retail prices
    return feature.dbFeature.price
  }
  if (settings.showSalePrices && (typeof feature.dbFeature.fabricatorCost == "number") && (feature.dbFeature.fabricatorCost > 0)) {
    return feature.dbFeature.fabricatorCost
  }
  return feature.dbFeature.cost
}


/**
 *
 * @param fabricatorData {object}
 * @param forTotal {boolean}
 * @return {boolean}
 */
export const getShowPrice = (fabricatorData, forTotal = false) => {
  const fabricatorSettings = fabricatorData.settings;
  if (forTotal) {
    return fabricatorSettings.showPricing && !fabricatorData.hidePricesFromUser;
  }
  return fabricatorSettings.showPricing && !fabricatorData.hideCheckoutBreakdownCost && !fabricatorData.hidePricesFromUser;
};
